import { signupFormWithAnalyticsSchema } from "@redotech/redo-model/signup-form-schema";
import * as z from "zod/v4";

export const getSignupFormById = {
  name: "getSignupFormById" as const,
  input: z.object({ formId: z.string() }),
  output: signupFormWithAnalyticsSchema,
};
